import React from "react";
import { NavbarProps } from "../common/types";
import { AnimIcon, Switch } from "../ui/Icons";
import styled from "styled-components";

const Nav = styled.div`
  display: flex;
  // border: 1px solid red;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0.5rem;
  background-color: ${({ theme }) => theme.body};
`;
const DashboardNavbar: React.FC<NavbarProps> = ({ toggleTheme, isDarkMode }) => (
    <Nav>
      <AnimIcon isDarkMode={isDarkMode} />
          <Switch toggleTheme={toggleTheme} isDarkMode={isDarkMode} />
    </Nav>
  );
  
  export default React.memo(DashboardNavbar);